module.exports = __webpack_public_path__ + "static/media/video-icon.6b0339e5.svg";